<template>
    <div class="container">

        <err-msg-bar :name="['pay_num']"></err-msg-bar>

        <div class="card" v-if="getLatestPointInfo.point">
            <div class="card-body">
                <div class="text-center"><b>前回発行情報({{getLatestPointInfo.point.pay_num}})</b></div>
            </div>
            <ul class="list-group list-group-flush">
                <li class="list-group-item d-flex">
                    <span>ポイント</span>
                    <span class="flex-fill text-right">
                        <small> {{getLatestPointInfo.point.points}}&nbsp;P </small>
                    </span>
                </li>
                <li class="list-group-item d-flex">
                    <span>件数</span>
                    <span class="flex-fill text-right">
                        <small> {{getLatestPointInfo.point.point_cnt}}&nbsp;件 </small>
                    </span>
                </li>
                <li class="list-group-item d-flex">
                    <span>開始</span>
                    <span class="flex-fill text-right">
                        <small>{{getLatestPointInfo.point.start_time | dformatf}}</small>
                    </span>
                </li>
                <li class="list-group-item d-flex">
                    <span>終了</span>
                    <span class="flex-fill text-right">
                        <small>{{getLatestPointInfo.point.end_time | dformatf}}</small>
                    </span>
                </li>
            </ul>
        </div>
        <!-- 0件メッセージ -->
        <not-found-msg v-else></not-found-msg>
    </div>
</template>

<script>
    import ErrMsgBar from 'pages/commons/err/ErrMsgBar'
    import NotFoundMsg from 'pages/commons/notFoundMsg/NotFoundMsg'
    
    import {mapGetters} from 'vuex'

    export default {
        components: {
            ErrMsgBar,
            NotFoundMsg
        },
        computed: {
            ...mapGetters(['getLatestPointInfo'])
        }

    }
</script>

<styley></styley>
